<template>
  <section class="custom-listing">
    <div class="row mb-2">
      <div class="col-md-2">
        <button class="btn btn-primary btn-sm" @click="addNew">Add</button>
      </div>
      <div class="col-md-9"></div>
      <div class="col-md-1">
        <span class="custom-items-label">{{ numItems }} items</span>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 custom-wrapper">
        <z-table
          :value="media"
          sortBy="name"
          orderBy="asc"
          :columns="tableColumns"
          :isSingleRowDetail="false"
          @sort="setOrder"
          class="table table-bordered table-striped"
          detailColumnClass="z-column-60-center"
        >
          <template v-slot:tbody="props">
            <td class="z-column-60-center">
              <a href="#" @click="edit(props.row)">edit</a>
            </td>
            <td>{{ props.row.name }}</td>
            <td class="z-column-100-center">{{ props.row.duration }}</td>
            <td class="z-column-100-center">
              {{ formatDate(props.row.start_date) }}
            </td>
            <td class="z-column-100-center">
              {{ formatDate(props.row.end_date) }}
            </td>
            <td class="z-column-60-center">
              <a href="#" @click="remove(props.row)">remove</a>
            </td>
          </template>
          <template v-slot:empty> Nothing found! </template>
        </z-table>
      </div>
    </div>
    <media-dialog
      id="media-modal"
      :show="actionMedia"
      @close="closeModal"
      @saved="savedMedia"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
import MediaDialog from '@/Components/DashboardComponents/forms/media-dialog'
export default {
  name: 'media-listing',
  components: {
    ZTable,
    ConfirmRemove,
    MediaDialog,
  },
  data() {
    return {
      selected: null,
      itemId: null,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Media Link?',
      actionConfirmRemove: null,
      actionMedia: null,
    }
  },
  mounted() {
    this.selected = null
    this.loadMedia()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('dashboardComponents', ['dashboardComponent', 'media']),
    tableColumns() {
      let _columns = []
      _columns = [
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'name',
          label: 'Name',
          sortable: false,
        },
        {
          field: 'duration',
          label: 'Duration',
          sortable: false,
          class: 'z-column-100-center',
        },
        {
          field: 'date_start',
          label: 'Start',
          sortable: false,
          class: 'z-column-100-center',
        },
        {
          field: 'date_end',
          label: 'End',
          sortable: false,
          class: 'z-column-100-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
      return _columns
    },
    numItems() {
      let _data = 0
      if (this.media) {
        _data = this.media.length
      }
      return _data
    },
  },
  methods: {
    ...mapActions('dashboardComponents', [
      'getMedia',
      'resetMediaItem',
      'getMediaItem',
      'removeMedia',
    ]),
    formatDate(date) {
      return moment.utc(new Date(date)).format('MM/DD/YYYY')
    },
    showRemoval() {},
    closeModal() {
      this.actionConfirmRemove = null
      this.actionMedia = null
    },
    setOrder(column, order) {
      let sort = {
        on: column.field,
        dir: order,
      }
      console.log('Sorting Media', sort)
    },
    async loadMedia() {
      if (this.dashboardComponent.id !== null) {
        let data = {
          orgId: this.examineOrganization.id,
          componentId: this.dashboardComponent.id,
        }
        await this.getMedia(data)
      }
    },
    async addNew() {
      if (this.dashboardComponent.id === null) {
        await this.$emit('saveComponent')
      }
      let data = {
        orgId: this.examineOrganization.id,
        componentId: this.dashboardComponent.id,
      }
      console.log('Now loading New Media dialog', data)
      this.resetMediaItem(data)
      this.actionMedia = {
        isAdd: true,
        data: data,
      }
    },
    async savedMedia() {
      this.actionMedia = null
      await this.loadMedia()
    },
    async edit(data) {
      console.log('Edit Media', data)
      await this.getMediaItem(data.id)
      this.actionMedia = {
        isAdd: false,
        data: data,
      }
    },
    remove(data) {
      this.itemId = data.id
      this.actionConfirmRemove = true
    },
    async performRemove() {
      console.log('Remove Media', this.itemId)
      await this.removeMedia(this.itemId)
      this.actionConfirmRemove = null
      this.loadMedia()
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 500px;
  width: 100%;
}
.custom-listing {
  width: 100%;
}
.custom-items-label {
  position: relative;
  font-size: 0.9em;
}
</style>
